import { Injectable } from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { format, startOfWeek, setDay } from 'date-fns';

@Injectable()
export class GusDateAdapter extends DateFnsAdapter {
  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const formatString = style === 'long' ? 'EEEE' : 'EEEEEE';

    const startDate = startOfWeek(new Date(), { weekStartsOn: 0 });

    return Array.from({ length: 7 }, (_, i) => format(setDay(startDate, i), formatString));
  }
}
